<div class="flex-container-nowrap height-100vh flex-stretch overlay">
  <tech-menumain class="flex-container-nowrap flex-stretch"></tech-menumain>
  <div class="upNavbarContainer flex-column flex-stretch overlay">
    <tech-upnavbar></tech-upnavbar>
    <router-outlet class="seccionContainer"></router-outlet>
    <tech-footermain></tech-footermain>
    <tech-eva-chat *ngIf="showEvaChat"></tech-eva-chat>
  </div>
</div>
<tech-loading-screen></tech-loading-screen>
